import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue'),
    meta: { title: '注册' }
  },
  {
    path: '/',
    component: () => import('@/components/pageComponents/Layout.vue'),
    redirect: '/workspace',
    children: [
      {
        path: 'workspace',
        name: 'workspace',
        component: () => import('@/views/Workspace.vue'),
        meta: { title: '作品广场' }
      },
      {
        path: 'resources',
        name: 'resources',
        component: () => import('@/views/Resources.vue'),
        meta: { title: '创作资源' }
      },
      {
        path: 'story-creation',
        name: 'story-creation',
        component: () => import('@/views/StoryCreation.vue'),
        meta: { title: '故事创作' }
      },
      {
        path: 'my-script',
        name: 'my-script',
        component: () => import('@/views/MyScript.vue'),
        meta: { title: '我的剧本' }
      },
      {
        path: 'image-creation',
        name: 'image-creation',
        component: () => import('@/views/ImageCreation.vue'),
        meta: { title: '图像创作' }
      },
      {
        path: 'video-creation',
        name: 'video-creation',
        component: () => import('@/views/VideoCreation.vue'),
        meta: { title: '视频创作' }
      },
      {
        path: 'magic-tools',
        name: 'magic-tools',
        component: () => import('@/views/MagicTools.vue'),
        meta: { title: '魔法工具' }
      },
      {
        path: 'picture-book',
        name: 'picture-book',
        component: () => import('@/views/PictureBook.vue'),
        meta: { title: '绘本创作' }
      },
      {
        path: 'ppt-creation',
        name: 'ppt-creation',
        component: () => import('@/views/PPTCreation.vue'),
        meta: { title: 'PPT创作' }
      },
      {
        path: 'ai-musician',
        name: 'ai-musician',
        component: () => import('@/views/AIMusician.vue'),
        // 需要在页面间切换时保留已选择的歌手/描述/哼唱旋律等状态（仅刷新才重置）
        meta: { keepAlive: true, title: 'AI音乐家' }
      },
      {
        path: 'ai-musician/player',
        name: 'ai-musician-player',
        component: () => import('@/views/AIMusicPlayer.vue'),
        meta: { title: '音乐播放器' }
      },
      {
        path: 'ai-chip-designer',
        name: 'ai-chip-designer',
        component: () => import('@/views/AIChipDesigner.vue'),
        meta: { title: 'AI创芯家' }
      },
      {
        path: 'ai-agent',
        name: 'ai-agent',
        component: () => import('@/views/AIAgent.vue'),
        meta: { title: 'AI代理' }
      },
      {
        path: 'AiWsTest',
        name: 'AiWsTest',
        component: () => import('@/views/AiWsTest.vue'),
        meta: { title: 'AI WebSocket测试' }
      },
      {
        path: 'contact-academy',
        name: 'contact-academy',
        component: () => import('@/views/ContactAcademy.vue'),
        meta: { title: '联系学院' }
      },
      {
        path: 'course-schedule',
        name: 'course-schedule',
        component: () => import('@/views/CourseSchedule.vue'),
        meta: { requireRole: 'TEACHER', title: '课程表' }
      }

    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由拦截：未登录无法进入首页及其他业务页面
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - AI智学星球` : 'AI智学星球'
  const publicPaths = ['/login', '/register']
  const isPublic = publicPaths.includes(to.path)

  let userInfo = null
  const stored = window.localStorage.getItem('planetUserInfo')

  if (stored) {
    try {
      userInfo = JSON.parse(stored)
    } catch (e) {
      userInfo = null
    }
  }

  const isLoggedIn = !!(userInfo && (userInfo.accessToken || userInfo.token))

  // 未登录且访问受保护页面，统一重定向到登录页
  if (!isLoggedIn && !isPublic) {
    return next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
  }

  // 已登录访问登录页时，自动跳回首页
  if (isLoggedIn && to.path === '/login') {
    return next({ path: '/' })
  }

  next()
})

export default router
